import { useCallback, useEffect, useRef, useState } from "react";
import { axiosInstance } from "../../utils/axiosInstance";
import { CleanerAttendancePayload } from "./cleanerAttendanceTypes";

const POLL_MS = 60_000;

export function useCleanerAttendance() {
  const [data, setData] = useState<CleanerAttendancePayload | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [refreshing, setRefreshing] = useState(false);
  const visibleRef = useRef(true);

  const reload = useCallback(async (opts?: { soft?: boolean }) => {
    if (opts?.soft) setRefreshing(true);
    else setLoading(true);
    setError(null);
    try {
      const res = await axiosInstance.get<CleanerAttendancePayload>(
        "/ops/cleaner-attendance"
      );
      setData(res.data);
    } catch (err: any) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Failed to load cleaner attendance.";
      setError(msg);
      if (!opts?.soft) setData(null);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    const onVisibility = () => {
      visibleRef.current = document.visibilityState === "visible";
    };
    document.addEventListener("visibilitychange", onVisibility);
    const id = window.setInterval(() => {
      if (visibleRef.current) reload({ soft: true });
    }, POLL_MS);
    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.clearInterval(id);
    };
  }, [reload]);

  return { data, loading, error, refreshing, reload };
}
